import { Howl } from 'howler';
import { sample } from 'lodash';
import type { Asset } from '../../graph/schema-generated-types-educator';
import { SoundMap, SoundSource, SoundType } from './types';
import {
  loadAudioAsync,
  loadCaptionObject,
  transformPathToUrl,
} from '../../util/activity-audio-util';

export const getAudioAsset = async (
  soundObject: SoundSource | Asset,
  options: any = {}
): Promise<Howl> =>
  await Promise.all([loadAudioAsync(soundObject, options), loadCaptionObject(soundObject)]);

export const getAudioAssets = async (
  { src, name }: SoundType,
  soundMap: SoundMap | null,
  options?: any
): Promise<{ name: string; sound: any; captions: any } | void> => {
  const asset = src || getRandomSound(name, soundMap);
  if (asset.src) {
    const [sound, captions] = await getAudioAsset(asset, options);
    return { name, sound, captions };
  }
};

export const getRandomSound = (name: string, soundMap: SoundMap | null): SoundSource | Asset => {
  const sound = soundMap && soundMap[name] ? soundMap[name] : { fileList: [], path: '' };
  let output = { src: '', captions: '' };

  const { fileList, path } = sound;

  if (fileList && fileList.length) {
    const randSnd = sample(fileList) as any;
    output = transformPathToUrl(randSnd, path);
  }

  return output;
};

export const isEmptyAudio = (sound: Howl): boolean => !(sound?.sound && sound?.sound._src);

export const removeSound = (sound: any): void => {
  if (typeof sound === 'object' && 'once' in sound) {
    sound.stop();
    sound.off();
    if (sound.state() !== 'unloaded') sound.unload();
  }
};
